import React, { useState, useContext, useEffect } from 'react'
import styles from './style';
import { Button, InputCodigoVerificacion } from '@alquiler-argentina/aa-componentes';
import UserContext from '../ContextUser/Context';
import { Grid } from '@mui/material';
import { CognitoUser } from "amazon-cognito-identity-js";
import { useTheme } from '@mui/material';
import userPool from '../UserPool';
import { Typography } from '@mui/material'
import SuccessRegister  from '../SuccessRegister';
import AACargando from '../../Commons/AACargando';
import axios from 'axios';
import UpdatePassword from '../UpdatePassword';

export const VerificationCode = ( props ) => {
    const theme = useTheme()
    const classes = styles(theme);
    const [verification, setVerification] = useState("")
    const [buttonDisabled, setButton] = useState(false);
    const [verificationFailed, setFailed] = useState(false);
    const [successSign, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ updatePasword, setUpdatePassword ] = useState(false);
    const { authenticate } = useContext(UserContext);

    const Username = props.email;
    const Pool = userPool;
    const user = new CognitoUser({ Username, Pool })

    if(props.resendCode){
    useEffect(() => {
        user.resendConfirmationCode();
    }, [])
    }

    // Función que verifica el código
    const codeVerify = () => {
        setLoading(true)
        const verificationCode = verification;
        user.confirmRegistration(verificationCode, true, function (err, result) {
            if (err) {
                setVerification('------')
                setFailed(true)
                setLoading(false)
                user.resendConfirmationCode()
                return;
            } else {
                axios.post(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/verificar/usuarios`, { email: props.email });
                if(props.password){
                    onInit();
                    setSuccess(true);
                } else {
                    setUpdatePassword(true);
                }
                setLoading(false);
            }
        })
    };
    const onInit = () => {
        authenticate(props.email, props.password)
            .then( (data) => { 
            })
            .catch((err) => {
                Sentry.captureException(err, "Something is wrong verificationCode, function onInit");
            })
      }
    if (loading && !props.modalOpen){
        return (<div css={classes.aaLoader}><AACargando /></div>)
    }
    if (successSign){ 
        return(<SuccessRegister esTroya={props.esTroya ? true : false} email={props.email} createAnfitrion={props.createAnfitrion ? true : false} onInit={onInit()} onCloseLoginModal={props.onCloseLoginModal} anfitrion={props.createAnfitrion ? true : false} modalOpen={props.modalOpen}/>)
    } 
    if (updatePasword) {
        return (
          <UpdatePassword
            createAnfitrion={props.createAnfitrion}
            esTroya={props.esTroya}
            forgotPassword={props.forgotPassword}
            onCloseLoginModal={props.onCloseLoginModal}
            modalOpen={props.modalOpen}
            userEmail={props.email}
            tipo={props.tipo}
          />
        );
      }
    return (
        <div>
            {loading ? <div css={classes.aaLoaderModal}><AACargando /></div> : null }
            <div css={classes.paper} style={loading ? {display: 'none'} : null}>
                <Grid item xs={12}> 
                    <img src="https://img.alqastatic.com/_img_/isologo.png?w=48" alt="Logo AA" />    
                </Grid>
                <Typography css={classes.textoLogin} variant="h5" component="div">{props.title}</Typography>
                <div>
                    <Typography css={classes.firstText}> {props.subtitle} <span css={classes.boldText}>{props.email}</span></Typography>
                    <Typography
                    variant="body2"
                    component="div"
                    css={classes.subtitle}>
                    Si no recibiste el código en tu bandeja de entrada, revisá el correo no deseado o Spam.
                    </Typography>
                    <Grid container direction="column" alignItems="center">
                        <Grid item css={classes.verficationContainer}>
                            <InputCodigoVerificacion
                                placeholder='-'
                                onCompleted={() => setButton(true)}
                                onChange={(event) => { setVerification(event) }}
                                value={verification}
                                length={6}
                            />
                        </Grid>
                        {verificationFailed ? (<Typography variant="body2" css={classes.verificationFail}>Código incorrecto. Hemos enviado un nuevo código a tu correo electrónico para que ingreses.</Typography>) : null}
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            onClick={codeVerify}
                            disabled={buttonDisabled ? false : true}
                            size="large"
                            color="primary"
                            fullWidth
                            css={classes.submit}
                        >
                            Verificar correo electrónico
                        </Button>
                    </Grid>
                </div>
            </div>
        </div>
    )
}

